import altflowAwsApi from './altflow-aws-api';
export const getUserAnswers = async (flowSlug, userId) => {
    if (!userId || !flowSlug)
        return null;
    const { data } = await altflowAwsApi.get(`/flows/${flowSlug}/answers?userId=${userId}`);
    return data;
};
